import { ActionBase } from '../../../core/store/action/ActionBase';

export const CONFIGURE_REPORTING = '[Submission] Configure Reporting';

export class ConfigureReportingAction implements ActionBase {
  readonly identifier = new Date().getTime().toString();
  readonly type = CONFIGURE_REPORTING;

  constructor(public payload: { submittingEntityKey: string }) {}
}



// WEBPACK FOOTER //
// ./src/app/submission/store/actions/ConfigureReportingAction.ts